import { LocaleGate } from "@web-monorepo/i18n";
import { overrideLocalLanguage } from "@web-monorepo/dates";
import { LoadingMojo, showTranslationErrorNotification } from "@web-monorepo/molecules";
import { captureException, setTag } from "@web-monorepo/telemetry";
import { coerceError } from "@web-monorepo/utilities";
import { Suspense, useEffect, type ReactNode } from "react";

type I18NContainerProps = {
  locale: string | null;
  children: ReactNode;
};

// The page still works, in English, so it says why rather than failing.
function reportCatalogError(error: unknown) {
  captureException(coerceError(error));
  showTranslationErrorNotification();
}

// Use the session locale, or the browser language when signed out.
export default function I18NContainer({ locale, children }: I18NContainerProps) {
  const resolved = locale || navigator.language;
  useEffect(() => {
    overrideLocalLanguage(resolved);
    setTag("page_locale", resolved);
    setTag("navigator_language", navigator.language);
  }, [resolved]);
  return (
    <Suspense fallback={<LoadingMojo noOverlay border />}>
      <LocaleGate language={resolved} onError={reportCatalogError}>
        {children}
      </LocaleGate>
    </Suspense>
  );
}
